/**
 * 機種別商圏の商圏(isSyoken)列を「商圏全体＋ホール」に展開する際に使用するホール一覧を返す。
 *
 * 背景:
 *   ヘッダー2段目は `[商圏全体, 自店, 商圏店舗…]` の順で、自店 = `hallsOfMarketArea` の先頭
 *   （店舗セレクターで選択中の店。バックエンドが先頭に配置する）。
 *   自店差系メトリック（列名に `(自店差)` を含む列）は「自店との差」を表すため、自店自身の差は
 *   意味を持たず、レスポンス（`row.data`）から自店セルが省かれて返る。
 *   そのため自店差列の展開では先頭ホール（自店）を除外し、ヘッダーと `row.data` の位置を一致させる。
 */

/** 列が自店差系メトリック（列名に `(自店差)` を含む / code に `JitenDifference` を含む）か判定する。 */
export const isJitenDifferenceColumn = (column: {
  name: string;
  code: string | null;
}): boolean =>
  column.name.includes('(自店差)') ||
  (column.code?.includes('JitenDifference') ?? false);

/**
 * 商圏(isSyoken)列の展開に使うホール一覧を返す。
 * 自店差列は自店（先頭ホール）セルがレスポンスに含まれないため除外する。
 */
export const getKiSyokenColumnHalls = <Hall>(
  column: { name: string; code: string | null },
  hallsOfMarketArea: readonly Hall[]
): Hall[] =>
  isJitenDifferenceColumn(column)
    ? hallsOfMarketArea.slice(1)
    : [...hallsOfMarketArea];
